export default "__VITE_ASSET__3d3aede5__"